module.exports = __webpack_public_path__ + "img/environment_bathroom2.3f55581e.jpg";